import {useContext} from "react";
import {previewQCContext, type PreviewQCContextValue} from "./previewQCContext.ts";

export const usePreviewQC = (): PreviewQCContextValue => {
  const context = useContext(previewQCContext);
  if (!context) throw new Error("usePreviewQC must be used within PreviewQCProvider");
  return context;
};
